import { useDOMPurify } from '../../lib/useDOMPurify';
import { EasyStepBlockProps } from '../../types/optimizely/blocks/easyStepsBlock';
import { AppStoreButton } from '../StoreButton/AppStoreButton';
import { GooglePlayButton } from '../StoreButton/GooglePlayButton';



const IndexIndicator = ({ index }: { index: number }) => (
    <div className="absolute top-[-36px] left-[50%] translate-x-[-50%] right-4 w-[4rem] h-[4rem] flex items-center justify-center rounded-full bg-primary-lightViolet text-white text-2xl">
        {index + 1}
    </div>
);

const EasyStepBlock = ({ title, text, index, appStoreUrl, googlePlayUrl, displayDownloadUrls, downloadAppFromAppstoreLabel, downloadAppFromGooglePlayLabel }: EasyStepBlockProps) => {
    const sanitizedContent = useDOMPurify(text);

    return (
        <div className="relative p-8 w-full bg-neutralGray rounded-2xl text-center text-primary-darkViolet flex flex-col items-center">
            <IndexIndicator index={index} />
            <h4 className='text-xl'>{title}</h4>
            <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
            {displayDownloadUrls 
                ? <>
                    {appStoreUrl ? <AppStoreButton link={appStoreUrl} label={downloadAppFromAppstoreLabel}/> : <></>}
                    {googlePlayUrl ? <GooglePlayButton link={googlePlayUrl} label={downloadAppFromGooglePlayLabel}/> : <></>}
                </> 
                : <></>}
        </div>
    );
};

export default EasyStepBlock;